import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
 
const useStyles = makeStyles(() => ({
  dashboardContent: {
    minHeight: "calc(100vh - 108px) !important",
    "& .google-map-code": {
      height: "100%",
    },
    [theme.breakpoints.down(1537)]: {
      maxWidth: "100vw",
      overflowX: "hidden",
    },
  },
  notificationSection: {
    [theme.breakpoints.down(1537)]: {
      paddingRight: 0,
      marginRight: 0,
    },
  },
}));
 
export default useStyles;

